import { Injectable } from '@angular/core';
import { HttpEvent, HttpErrorResponse, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { CommonService } from '../services';
import { retry, catchError } from 'rxjs/operators';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private commonService: CommonService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .pipe(
        // retry(1),
        catchError(
          (error: HttpErrorResponse) => {
            if (error && error.url && error.url.toLowerCase().includes("account/login?returnurl")) {
              window.location.reload();
            }

            // below needs to be updated in future with all scenarios based on client session .....
            // skip error status 502 bad gateway
            if (error.status != 200 && error.status != 502 && error.name == "HttpErrorResponse") {
              // this.router.navigateByUrl('/404', {skipLocationChange: true});
              if (error.error.length) {
                this.commonService.implementToast(error.error, "Error");
              }
            }

            // let errorMessage = '';

            // if (error.error instanceof ErrorEvent) {
            //   // client-side error
            //   errorMessage = `Error: ${error.error.message}`;
            // } else {
            //   // server-side error
            //   errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
            // }
            // console.log(errorMessage);
            return throwError(error.error);
            //return Observable.throw(error.error || 'ASP.NET Core server error');
          }
        )
      )
  }
}
